<!-- Main view when user is logged in -->
<template>
  <v-app>
    <PowerGuardNavBar />

    <v-main class="ma-4">
      <router-view name="powerguardview"></router-view>
    </v-main>
    <Footer />
  </v-app>
</template>
<script>
import PowerGuardNavBar from '@/components/PowerGuard/Menu/PowerGuardNavBar';
import Footer from '@/components/PowerGuard/Menu/Footer';

export default {
  data() {
    return {
      username: '',
    };
  },
  components: {
    PowerGuardNavBar,
    Footer,
  },
  async created() {
    // if (!this.$store.getters.isLoggedIn) {
    //  this.$router.push('/login');
    // }
    this.username = this.$store.getters.getUser.username;
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
};
</script>
